module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products/all-products/all-products.component.css
// module id = ./src/app/products/all-products/all-products.component.css
// module chunks = main